import api from './base';
export interface GlobalSetting {
    maxConnectRequests: number;
    connectionExpiryInDays: number;
    connectionExpiryReminder: number;
}
export const getGlobalSettingsApi = async () =>
    api.get('/global-setting') as Promise<{ data: { attributes: GlobalSetting } }>;